export const COLUMNS_ENUM = Object.freeze({
  AUTONOMOUS_SYSTEM: { order: 0, name: "Number" },
  DISPLAYED: { order: 1, name: "Displayed" },
});
